import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../core/guards/auth-guard.service';
import { EnsureFormNotDirtyGuard } from '../../core/guards/ensure-form-not-dirty.guard';
import { HeaderBar } from '../../core/services/header-bar.service';
import { SideBar } from '../../core/services/side-bar.service';
import { AccreditedInvestorOptInComponent } from './pages/accredited-investor-opt-in/accredited-investor-opt-in.component';
import { AccreditedInvestorComponent } from './pages/accredited-investor/accredited-investor.component';
import { ConfirmationComponent } from './pages/confirmation/confirmation.component';
import { FinancialSituationComponent } from './pages/financial-situation/financial-situation.component';
import { NonRecommendedProductsComponent } from './pages/non-recommended-products/non-recommended-products.component';
import { OrganizationInformationComponent } from './pages/organization-information/organization-information.component';
import { RecommendedProductsComponent } from './pages/recommended-products/recommended-products.component';
import { ReviewAndSubmitComponent } from './pages/review-and-submit/review-and-submit.component';
import { RiskAndObjectivesComponent } from './pages/risk-and-objectives/risk-and-objectives.component';
import { RiskProfileAssessmentComponent } from './pages/risk-profile-assessment/risk-profile-assessment.component';
import { CanDeactivateGuard } from '../../core/guards/can-deactivate.guard';
import { AccreditedInvestorConfirmationComponent } from './pages/accredited-investor-confirmation/accredited-investor-confirmation.component';
import { ConfirmationLoadingComponent } from './pages/confirmation-loading/confirmation-loading.component';

const routes: Routes = [
  {
    path: 'fna',

    // Can comment this during debugging if you don't want to keep getting redirected to login.
    //canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: '',
        redirectTo: '/fna/accredited-investor',
        pathMatch: 'full',
      },
      {
        path: 'accredited-investor',
        component: AccreditedInvestorComponent,
        data: {
          sideBarState: SideBar.Default,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Accredited Investor',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'organisation-information',
        component: OrganizationInformationComponent,
        data: {
          id: 'organisation-information',
          sideBarState: SideBar.Stepper,
          step: 1,
          headerBarState: HeaderBar.ShowSaveButton,
          title: "Organisation's information",
        },
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'financial-situation',
        component: FinancialSituationComponent,
        data: {
          id: 'financial-situation',
          sideBarState: SideBar.Stepper,
          step: 2,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Financial situation',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'risk-and-objectives',
        component: RiskAndObjectivesComponent,
        data: {
          id: 'risk-and-objectives',
          sideBarState: SideBar.Stepper,
          step: 3,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Risk and objectives',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'risk-profile-assessment',
        component: RiskProfileAssessmentComponent,
        data: {
          id: 'risk-profile-assessment',
          sideBarState: SideBar.Stepper,
          step: 4,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Risk profile assessment',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'recommended-products',
        component: RecommendedProductsComponent,
        data: {
          id: 'recommended-products',
          sideBarState: SideBar.Stepper,
          step: 5,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Recommended products',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'non-recommended-products',
        component: NonRecommendedProductsComponent,
        data: {
          id: 'non-recommended-products',
          sideBarState: SideBar.Stepper,
          step: 6,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Non-recommended products',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'review-and-submit',
        component: ReviewAndSubmitComponent,
        data: {
          id: 'review-and-submit',
          sideBarState: SideBar.Stepper,
          step: 7,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Review',
        },
        canDeactivate: [EnsureFormNotDirtyGuard, CanDeactivateGuard],
      },
      {
        path: 'confirmation',
        component: ConfirmationComponent,
        data: {
          sideBarState: SideBar.None,
          headerBarState: HeaderBar.Default,
        },
      },
      {
        path: 'confirmation-loading',
        component: ConfirmationLoadingComponent,
        data: {
          sideBarState: SideBar.None,
          headerBarState: HeaderBar.Default,
        },
      },
      {
        path: 'accredited-investor-application',
        component: AccreditedInvestorOptInComponent,
        data: {
          sideBarState: SideBar.Default,
          headerBarState: HeaderBar.ShowSaveButton,
          title: 'Accredited investor Application',
        },
        canDeactivate: [EnsureFormNotDirtyGuard],
      },
      {
        path: 'accredited-investor-confirmation',
        component: AccreditedInvestorConfirmationComponent,
        data: {
          sideBarState: SideBar.None,
          headerBarState: HeaderBar.Default,
        },
      },
      // {
      //   path: '**',
      //   component: PageNotFoundComponent
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FnaRoutingModule {}
